import FilterResolveDresonRule from "./FilterResolveDresonRule";
import { DresonRuleResolvedEvent, OrchestrationTopics } from "../../types/FilterTypes";
import LoadLocalNavigation from "./LoadLocalNavigation";
import LoadBreadCrumb from "./LoadBreadCrumb";
import LoadNavConsultantText from "./LoadNavConsultantText";
import LoadBottomLinks from "./LoadBottomLinks";
import LoadNavSidebarText from "./LoadNavSidebarText";
import { eventQBus } from "../../types/EventQBus";
import LoadSeoMetaBlock from "./LoadSeoMetaBlock";
import LoadNavCategorySlider from "./LoadNavCategorySlider";
import { TopicPageFilterHandler } from "./TopicPageFilterHandler";

export default class MultiFiltering {
  private static hasBeenInitialized = false;

  public static init() {
    if (MultiFiltering.hasBeenInitialized) {
      return;
    }
    MultiFiltering.hasBeenInitialized = true;

    eventQBus.on("ftfind.dresonRule.resolve", FilterResolveDresonRule.resolve);

    MultiFiltering.onResolved("ftfind.tilelist.load");

    MultiFiltering.onResolved("ftfind.breadcrumb.load");
    eventQBus.on("ftfind.breadcrumb.load", LoadBreadCrumb.onLoadBreadcrumb);

    MultiFiltering.onResolved("ftfind.localNavigation.load");
    eventQBus.on("ftfind.localNavigation.load", LoadLocalNavigation.onLoadLocalNavigation);

    MultiFiltering.onResolved("ftfind.navConsultantText.load");
    eventQBus.on("ftfind.navConsultantText.load", LoadNavConsultantText.onLoadNavConsultantText);

    MultiFiltering.onResolved("reptile.bottomLinks.load");
    eventQBus.on("reptile.bottomLinks.load", LoadBottomLinks.onLoadBottomLinks);

    MultiFiltering.onResolved("ftfind.navSidebarText.load");
    eventQBus.on("ftfind.navSidebarText.load", LoadNavSidebarText.onLoadNavSidebarText);

    MultiFiltering.onResolved("reptile.seoMetaBlock.load");
    eventQBus.on("reptile.seoMetaBlock.load", LoadSeoMetaBlock.onLoadSeoMetaBlock);

    new TopicPageFilterHandler().init();
  }

  private static onResolved(topic: keyof OrchestrationTopics) {
    eventQBus.on("ftfind.dresonRule.resolved", (data: DresonRuleResolvedEvent) => {
      if (data.count === 0) {
        return;
      }

      eventQBus.emit(topic, data);
    });
  }
}
